export default __webpack_public_path__ + "static/1186-767089a528493303cb3520952669a969.gif";